export const DASHBOARD_ROUTES = {
  DASHBOARD: '/',
} as const;
